import APIs from '../../apiUrl';

const userGetAllProduct = async (payload) => {
  try {
    const response = await APIs.get(
      `/user_get_all_product/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const userGetSingleProductDetails = async (payload) => {
  try {
    const response = await APIs.get(`/user_get_single_product/${payload?.Id}`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const UserSearchForProductByTitle = async (payload) => {
  try {
    const response = await APIs.get(
      `/user_search_for_product_by_title/${payload?.title}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const UserProductsServices = {
  userGetAllProduct,
  userGetSingleProductDetails,
  UserSearchForProductByTitle,
};

export default UserProductsServices;
